import React from "react";
import { Button, CircularProgress, Typography, makeStyles } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  root: { flex: 1, minHeight: 180, width: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 12, padding: theme.spacing(4), background: theme.palette.background.default, color: theme.palette.text.secondary },
}));
export default function PageLoading() {
  const classes = useStyles();
  return <div className={classes.root} role="status" aria-live="polite"><CircularProgress size={28} /><Typography variant="body2">Carregando página...</Typography></div>;
}

function PageLoadFailure() {
  const classes = useStyles();
  return <div className={classes.root} role="alert"><Typography variant="body2">Não foi possível abrir esta página.</Typography><Button color="primary" variant="outlined" onClick={() => window.location.reload()}>Atualizar página</Button></div>;
}
export class PageLoadBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() { return this.state.failed ? <PageLoadFailure /> : this.props.children; }
}
